export default __webpack_public_path__ + "static/media/valley13.d3398f40.png";